import { render, staticRenderFns } from "./TestPackageGroupAdd.vue?vue&type=template&id=3766c59b"
import script from "./TestPackageGroupAdd.vue?vue&type=script&lang=js"
export * from "./TestPackageGroupAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports